import { render, staticRenderFns } from "./InformationBlock.vue?vue&type=template&id=7c54a199&scoped=true&"
import script from "./InformationBlock.vue?vue&type=script&lang=ts&"
export * from "./InformationBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54a199",
  null
  
)

export default component.exports